import script from "./ActivityCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivityCard.vue?vue&type=script&setup=true&lang=js"

import "./ActivityCard.vue?vue&type=style&index=0&id=23fbb6fa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23fbb6fa"]])

export default __exports__